const SAVE = "SAVE_NOTIFICATION_ITEM_ADDED";

export function showNotificationItemAddedReducer(state = false, action) {
  switch (action.type) {
    case SAVE:
      return action.payload;
    default:
      return state;
  }
}
